import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/Service/api.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

import {

  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexStroke,
  ApexMarkers,
  ApexYAxis,
  ApexGrid,
  ApexTitleSubtitle,
  ApexLegend,
  ApexPlotOptions,
  ApexFill,
  ApexTooltip,
  ApexNonAxisChartSeries,
  ApexResponsive
} from "ng-apexcharts";


export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  markers: ApexMarkers;
  colors: string[];
  yaxis: ApexYAxis;
  grid: ApexGrid;
  legend: ApexLegend;
  title: ApexTitleSubtitle;
};
export type ChartOptions2 = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
};
export type ChartOptions3 = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
};
interface DataItem {
  PINCODE: number
  COUNT: number
}
interface DataItem1 {
  NAME: string
  CHAPTERS_COUNT: number
  BATCH_COUNT: number
  VIDEO_COUNT: number
}
interface DataItem2 {
  NAME: string
  WATCHED_COUNT: number
  WATCHING_TIME: number
  LIKE_COUNT: number
  TOTAL_COMMENTS: number
}



@Component({
  selector: 'app-admindashboard',
  templateUrl: './admindashboard.component.html',
  styleUrls: ['./admindashboard.component.css']
})
export class AdmindashboardComponent implements OnInit {

  TYPE = true;
  isSpinning = false
  logtext = ""
  filterQuery: string = "";

  pincodeWiseData = [];
  liveVideoCount = [];
  courseWiseCount = [];

  listOfColumn = [
    {
      title: 'Pincode',
      compare: (a: DataItem, b: DataItem) => a.PINCODE - b.PINCODE,
    },
    {
      title: 'Count',
      compare: (a: DataItem, b: DataItem) => a.COUNT - b.COUNT,
    },

  ];

  listOfColumn1 = [
    {
      title: 'Name',
      compare: (a: DataItem1, b: DataItem1) => a.NAME.localeCompare(b.NAME),
    },
    {
      title: 'Chapter Count',
      compare: (a: DataItem1, b: DataItem1) => a.CHAPTERS_COUNT - b.CHAPTERS_COUNT,
    },
    {
      title: 'Batch Count',
      compare: (a: DataItem1, b: DataItem1) => a.BATCH_COUNT - b.BATCH_COUNT,
    },
    {
      title: 'Video Count',
      compare: (a: DataItem1, b: DataItem1) => a.VIDEO_COUNT - b.VIDEO_COUNT,
    },

  ];
  listOfColumn2 = [
    {
      title: 'Video Name',
      compare: (a: DataItem2, b: DataItem2) => a.NAME.localeCompare(b.NAME),
    },
    {
      title: 'Watched Count',
      compare: (a: DataItem2, b: DataItem2) => a.WATCHED_COUNT - b.WATCHED_COUNT,
    },
    {
      title: 'Watching Time',
      compare: (a: DataItem2, b: DataItem2) => a.WATCHING_TIME - b.WATCHING_TIME,
    },
    {
      title: 'Total Likes',
      compare: (a: DataItem2, b: DataItem2) => a.LIKE_COUNT - b.LIKE_COUNT,
    },
    {
      title: 'Total Comments',
      compare: (a: DataItem2, b: DataItem2) => a.TOTAL_COMMENTS - b.TOTAL_COMMENTS,
    },

  ];



  columns: string[][] = [['NAME', 'Video Name'], ['WATCHED_COUNT', 'Watched Count'], ['WATCHING_TIME', 'Watching Time'], ['LIKE_COUNT', 'Total Likes'], ['TOTAL_COMMENTS', 'Total Comments']]
  columns2: string[][] = [['NAME', 'Course Name'], ['CHAPTERS_COUNT', 'Chapters'], ['BATCH_COUNT', 'Batches'], ['VIDEO_COUNT', 'Videos']]

  public chartOptions: Partial<ChartOptions>;
  public chartOptions3: Partial<ChartOptions3>;
  public chartOptions4: Partial<ChartOptions2>;


  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;



  date = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + 1

  lineChartLabels = []
  lineChartData = []
  pieData = []
  ONEMAN_COUNT = 0
  JOINED_TO_ONEMAN_COUNT = 0
  GAVALI_COUNT = 0
  JOINED_TO_GAVALI_COUNT = 0
  DAIRY_COUNT = 0
  JOINED_TO_DAIRY_COUNT = 0
  CHILLING_COUNT = 0
  JOINED_TO_CHILLING_COUNT = 0
  STATUS_CODE = 0

  constructor(private api: ApiService, private message: NzNotificationService) {

  }

  ngOnInit() {
    this.onChange(new Date());
  }
  onChange(result: Date): void {
    this.isSpinning = true;
    var month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    var lastDate = new Date(result.getFullYear(), result.getMonth() + 1, 0);
    this.lineChartLabels = []
    this.lineChartData = [];

    this.api.getAllDashboarddata((result.getMonth() + 1), result.getFullYear()).subscribe(data => {

      if (data['code'] == 200) {
        this.STATUS_CODE = 200


        this.ONEMAN_COUNT = data['data'][0]['STAT_DATA'][0]['ONE_MAN_TOTAL']
        this.JOINED_TO_ONEMAN_COUNT = data['data'][0]['STAT_DATA'][0]['M_FARMER_COUNT']
        this.GAVALI_COUNT = data['data'][0]['STAT_DATA'][0]['GAVALI_TOTAL']
        this.JOINED_TO_GAVALI_COUNT = data['data'][0]['STAT_DATA'][0]['G_FARMER_COUNT']
        this.DAIRY_COUNT = data['data'][0]['STAT_DATA'][0]['DAIRY_OUTLET_TOTAL']
        this.JOINED_TO_DAIRY_COUNT = data['data'][0]['STAT_DATA'][0]['O_FARMER_COUNT']
        this.CHILLING_COUNT = data['data'][0]['STAT_DATA'][0]['CHILLING_CENTER_TOTAL']
        this.JOINED_TO_CHILLING_COUNT = data['data'][0]['STAT_DATA'][0]['C_GAVALI_COUNT']
        this.pincodeWiseData = data['data'][0]['PINCODE_DATA']
        // this.liveVideoCount=data['data'][0]['LIVE_DATA']
        this.courseWiseCount = data['data'][0]['COURSE_DATA']

        this.liveVideoCount = data['data'][0]['LIVE_DATA'];
        // this.liveVideoCount = data['data'][0]['LIVE_DATA'].slice(0, 10);

        this.pieData = data['data'][0]['PIE_CHART_DATA']

        data['data'][0]['LINE_CHART_DATA'].forEach((e) => { this.lineChartData.push(e.COUNT) })

        for (var i = 0; i < lastDate.getDate(); i++) {
          this.lineChartLabels.push((i + 1) + "-" + month_names_short[result.getMonth()])
        }

        this.setLineChart();
        this.setPieChart();

      }
      else {
        this.message.error(data['message'], "");
      }
      this.isSpinning = false;
    }, err => {
      if (err['ok'] == false)
        this.message.error("Server Not Found", "");
    });

  }



  setLineChart() {
    this.chartOptions = {
      series: [
        {
          name: " Farmers Joined",
          data: this.lineChartData
        }
      ],
      chart: {
        height: 350,
        type: "line",
        dropShadow: {
          enabled: true,
          color: "#000",
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2
        },
        toolbar: {
          show: false
        }
      },
      colors: ["#77B6EA"],
      dataLabels: {
        enabled: true
      },
      stroke: {
        curve: "straight"
      },
      title: {
        text: "",
        align: "left"
      },
      grid: {
        borderColor: "#e7e7e7",
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      markers: {
        size: 1
      },
      xaxis: {
        categories: this.lineChartLabels,
        title: {
          text: "Date"
        }
      },
      yaxis: {
        title: {
          text: "Count"
        },

      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        floating: true,
        offsetY: -25,
        offsetX: -5
      }
    };


  }

  setPieChart() {
    this.chartOptions3 = {
      series: [this.pieData[0]['COMPLETED'], this.pieData[0]['ONGOING'], this.pieData[0]['UPCOMMING']],
      chart: {
        width: 350,
        type: "pie"
      },
      labels: ["Completed", "Ongoing", "Upcomming"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ]
    };
  }

  getTime(sec) {
    return this.api.getSecondsToHms(sec)
  }



}
